import choiceReducers from '../choice/choice.reducer';

function saveQuestion(sess, question) {
    const {Question} = sess;
    const choicesModels = question.choices.map(choice => {
        return choiceReducers.saveChoice(sess, choice)
    })
    return Question.create({
        ...question,
        choices: choicesModels
    })
} 

function removeQuestion(sess, id) {

}

function checkQuestion(sess, id, answer, hint) {
    const {Question} = sess;
    if (!Question.idExists(id)) {
        throw new Error(`there is\`nt any question with this id: ${id}`);
    }
    const questionTarget = Question.withId(id);
    questionTarget.update({
        hint: hint,
    });
    const questionChoices = questionTarget.choices.toModelArray();
    questionChoices.forEach((choice, index) => {
        if (choice.id === answer) {
            choice.update({
                isCorrect: true,
            });
        } else {
            choice.update({
                isCorrect: false,
            });
        }
    });
    
}


export default {
    saveQuestion,
    removeQuestion,
    checkQuestion,
}